export default {
    OLX_CL: 'olxcl',
    OLX_MX: 'olxmx',
    OLX_IN: 'olxin',
    OLX_CR: 'olxcr',
    OLX_ID: 'olxid',
    OLX_CO: 'olxco',
    OLX_EC: 'olxec',
    OLX_GT: 'olxgt',
    OLX_EG: 'olxeg',
    OLX_LB: 'olxlb',
    OLX_PA: 'olxpa',
    OLX_PE: 'olxpe',
    OLX_PK: 'olxpk',
    OLX_SV: 'olxsv',
    OLX_ZA: 'olxza',
    OLX_AR: 'olxar',
    OLX_TR: 'olxtr',
    OLX_PL: 'olxpl'
};
